import EvaluacionDisciplinaAdministrativa from '../../domain/entities/EvaluacionDisciplinaAdministrativa'
import { getIncidencias } from '../../domain/rules/evaluacionDisciplinaAdministrativa.rules'
import EvaluacionDisciplinaAdministrativaAdapter from '../adapters/EvaluacionDisciplinaAdministrativa.adapter'

export default class CreateEvaluacionDisciplinaAdministrativaUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacionDesempenio, faltasAdministrativas) {
    try {
      const evaluacion = new EvaluacionDisciplinaAdministrativa(evaluacionDesempenio.idEvaluado)
      evaluacion.idEvaluador = evaluacionDesempenio.idEvaluador
      evaluacion.idPeriodicidad = evaluacionDesempenio.idPeriodicidad
      evaluacion.fechaInicio = evaluacionDesempenio.fechaInicio
      evaluacion.fechaConclusion = evaluacionDesempenio.fechaConclusion
      evaluacion.fechaAplicacion = evaluacionDesempenio.fechaAplicacion
      evaluacion.incidencias = getIncidencias(faltasAdministrativas, evaluacionDesempenio.fechaAplicacion)

      const dto = EvaluacionDisciplinaAdministrativaAdapter.toDto(evaluacion)
      const { data } = await this.#repository.create(dto)

      return data[0].ID
    } catch (error) {
      throw new Error(`Failed to execute CreateEvaluacionDisciplinaAdministrativaUseCase: ${error.message}`)
    }
  }
}
